// Auto-generated by scripts/generate-version.js
export const APP_VERSION = 'v2.8.90';
export default APP_VERSION;
